"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isEcommEvent = function (event) {
    return [
        'addTransaction',
        'addItem',
        'addImpression',
        'addProduct',
        'addPromo',
        'addAction',
        'ecommSend',
        'ecommClear',
    ].indexOf(event.hitType) > -1;
};
exports.default = isEcommEvent;



//////////////////
// WEBPACK FOOTER
// ../~/@redux-beacon/google-analytics/dist/utils/is-ecomm-event.js
// module id = 685
// module chunks = 0